import DocumentEnterpriseComponentMetadata from "./ec/impl/Docs/DocumentEnterpriseComponentMetadata";

// The enterprise component metadata this app can build by name.
//
// REGISTERING HERE IS NOT OPTIONAL. EnterpriseComponent's constructor calls `new` on whatever this
// returns, so a component whose metadata is missing throws "<minified> is not a constructor" from
// inside a useState initializer -- which unmounts the entire React tree and leaves a blank page
// naming no component. It is the first thing to check when a new component blanks the app.
const enterpriseComponentMetadataClasses: Map<string, object> = new Map();

enterpriseComponentMetadataClasses.set("DocumentEnterpriseComponentMetadata", DocumentEnterpriseComponentMetadata);

export default function enterpriseObjectMetadataClassFactory(name: string): Object | undefined {
    return enterpriseComponentMetadataClasses.get(name + "EnterpriseComponentMetadata");
}
